var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.0833 3.66667H7.15C5.60986 3.66667 4.83978 3.66667 4.25153 3.9664C3.73408 4.23005 3.31338 4.65075 3.04973 5.16819C2.75 5.75645 2.75 6.52652 2.75 8.06667V14.85C2.75 16.3901 2.75 17.1602 3.04973 17.7485C3.31338 18.2659 3.73408 18.6866 4.25153 18.9503C4.83978 19.25 5.60986 19.25 7.15 19.25H13.9333C15.4735 19.25 16.2436 19.25 16.8318 18.9503C17.3493 18.6866 17.7699 18.2659 18.0336 17.7485C18.3333 17.1602 18.3333 16.3901 18.3333 14.85V11.9167M11.9167 15.5833H6.41667M13.75 11.9167H6.41667M18.4445 3.55546C19.5185 4.6294 19.5185 6.3706 18.4445 7.44454C17.3706 8.51849 15.6294 8.51849 14.5555 7.44454C13.4815 6.3706 13.4815 4.6294 14.5555 3.55546C15.6294 2.48151 17.3706 2.48151 18.4445 3.55546Z",
    stroke: "#FFE600",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationText);
export default __webpack_public_path__ + "static/media/notification_text.edc14c7c2903442a8cd027a81abf4b44.svg";
export { ForwardRef as ReactComponent };